import { render } from "./HistoryView.vue?vue&type=template&id=442cd862&scoped=true&ts=true"
import script from "./HistoryView.vue?vue&type=script&lang=ts"
export * from "./HistoryView.vue?vue&type=script&lang=ts"

import "./HistoryView.vue?vue&type=style&index=0&id=442cd862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442cd862"]])

export default __exports__